var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import DescriptionColumn from "./descriptionColumn";
import DescriptionColumnHeading from "./descriptionColumnHeading";
import DescriptionColumns from "./descriptionColumns";
import DescriptionHeading from "./descriptionHeading";
import DescriptionText from "./descriptionText";
import * as styles from "./styles.css";
var Description = /** @class */ (function (_super) {
    __extends(Description, _super);
    function Description() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Description.prototype.render = function () {
        var _a = this.props, children = _a.children, rest = __rest(_a, ["children"]);
        return (React.createElement("div", __assign({ className: styles.description }, rest), children));
    };
    Description.Column = DescriptionColumn;
    Description.ColumnHeading = DescriptionColumnHeading;
    Description.Columns = DescriptionColumns;
    Description.Heading = DescriptionHeading;
    Description.Text = DescriptionText;
    return Description;
}(React.Component));
export default Description;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/description/description.tsx
// module id = 0Tsv
// module chunks = 2